import {
  isDuctedRailSectionSkipped,
  rankGroupTailSelections
} from 'utils/ducted-rail-selections';
import { DuctedRailSectionModel } from './ducted-rail-sections-types';

export type DuctedRailCounts = {
  shownCount: number;
  totalCount: number;
};

const leadCardCount = (
  group: DuctedRailSectionModel['rankGroups'][number]
): number =>
  group.cards.filter((card) => card.representative?.combination != null).length;

// "Showing N of M": the cards on screen against every row the server
// counts. Until "Show more" is clicked each type's leads show — the kept
// pairing and the full replacement — so the shown count is those leads.
export function ductedRailCounts(
  sections: DuctedRailSectionModel[],
  tailRevealed: boolean
): DuctedRailCounts {
  const totalCount = sections
    .flatMap((section) => section.subSections)
    .reduce((sum, subSection) => sum + subSection.displayTotalCount, 0);
  const shownCount = sections
    .filter((section) => !isDuctedRailSectionSkipped(section))
    .reduce((sum, section) => {
      const groups = section.rankGroups;
      const leads = groups.reduce(
        (groupSum, group) => groupSum + leadCardCount(group),
        0
      );
      if (!tailRevealed) return sum + leads;
      const tails = groups.reduce(
        (groupSum, group) =>
          groupSum + rankGroupTailSelections(section, group).length,
        0
      );
      return sum + leads + tails;
    }, 0);
  return { shownCount, totalCount };
}
